import { Column } from './types'
import { headerProps } from './useHeaderColumnProps'


const columnProps = {
  ...headerProps,
  [Column.Date]: { alignLeft: true },
}

export function useColumnProps() {
  return columnProps
}
